// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"6e94deed","239":"fe7c4c9e","453":"0543fa16","732":"8568181a"}[chunkId] + ".chunk.js";
};